/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ used: NonNullable<unknown>, limit: NonNullable<unknown> }} Settings_Credits_UsedInputs */

const en_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} credits used`)
};

const de_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} Aktionen verbraucht`)
};

const fr_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} actions utilisées`)
};

const es_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} acciones utilizadas`)
};

const it_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} crediti utilizzati`)
};

const nl_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} credits gebruikt`)
};

const pl_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} użytych kredytów`)
};

const fi_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} käytettyä kredittiä`)
};

const da_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} kreditter brugt`)
};

const sv_settings_credits_used = /** @type {(inputs: Settings_Credits_UsedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.used} / ${i?.limit} credits använda`)
};

/**
* | output |
* | --- |
* | "{used} / {limit} credits used" |
*
* @param {Settings_Credits_UsedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_credits_used = /** @type {((inputs: Settings_Credits_UsedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Credits_UsedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_credits_used(inputs)
	if (locale === "fr") return fr_settings_credits_used(inputs)
	if (locale === "es") return es_settings_credits_used(inputs)
	if (locale === "it") return it_settings_credits_used(inputs)
	if (locale === "nl") return nl_settings_credits_used(inputs)
	if (locale === "pl") return pl_settings_credits_used(inputs)
	if (locale === "fi") return fi_settings_credits_used(inputs)
	if (locale === "da") return da_settings_credits_used(inputs)
	if (locale === "sv") return sv_settings_credits_used(inputs)
	return en_settings_credits_used(inputs)
});